export default "__VITE_ASSET__ClHAoh3n__"